import styled from 'styled-components';

import SvgIcon from '~src/shared/SvgIcon';
import { media } from '~src/styles/media-templates';

export const CaretContainer = styled.div`
  color: ${({ theme }) => theme.baseBlue.a6};
  svg {
    stroke-width: 1.5px !important;
  }

  width: auto;
  float: right;
  ${media.phone`
      float: unset;
   `}
`;

export const ArrowIcon = styled(SvgIcon)<{ $open: boolean; $caretColor?: string }>`
  transform: ${({ $open }) => ($open ? 'rotate(180deg)' : 'none')};
  transition: transform 0.3s ease;
  color: ${({ $caretColor }) => $caretColor || 'inherit'};
  min-width: 15px;
  svg {
    stroke-width: 1.5px;
  }
`;

export const LinkTxt = styled.span<{ $noOverflow?: boolean }>`
  font-size: 0.8rem;
  letter-spacing: 0.3px;
  text-align: left;
  margin-right: 10px;
  font-weight: 600;
  width: auto;
  text-overflow: ${({ $noOverflow }) => ($noOverflow ? 'default' : 'ellipsis')};
  overflow: ${({ $noOverflow }) => ($noOverflow ? 'visible' : 'hidden')};
  white-space: nowrap;
  text-transform: uppercase;
`;

export const CaretTextContainer = styled.div.attrs({'data-testid': 'CaretTextContainer'})<{
  $size?: string;
  $maxWidth?: string;
  $isCursorDefault?: boolean;
}>`
  font-size: ${({ $size = '1rem' }) => $size};
  text-transform: uppercase;
  font-weight: normal;
  text-align: left;
  display: flex;
  cursor: ${({ $isCursorDefault }) => ($isCursorDefault ? 'default' : 'pointer')};
  align-items: center;
  justify-content: flex-end;
  width: fit-content;
  max-width: ${({ $maxWidth = '165px' }) => $maxWidth};
`;
